export const API_PATH_ApiAlertMgtmRegionLocationDeviceInfoGet = '/services/alert-mgtm/apiAlertMgtmRegionLocationDeviceInfoGet';
